import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BetweenNumbers } from '@common/models/between-numbers';

@Component({
    selector: 'between-numbers',
    templateUrl: './between-numbers.component.html'
})
export class BetweenNumbersComponent implements OnInit {

    @Input() model: BetweenNumbers;
    @Output() modelChange = new EventEmitter<any>();

  constructor() { }

   isObject(item) {
    return (typeof item === "object" && !Array.isArray(item) && item !== null);
  }

    ngOnInit() {
      if (!this.isObject(this.model) || this.model.field1 === undefined) {
        this.model = { field1: null, field2: null };
      }
    }

    field1Changed(newValue: number) {
        this.modelChange.emit(this.model);
    }

    field2Changed(newValue: number) {
        this.modelChange.emit(this.model);
    }

}
